import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import { adminSideLinks } from '../adminRoutes';

function AdminAnalyticsPage() {
  return (
    <DashboardShell role="ADMIN" sideLinks={adminSideLinks}>
      <div className="rounded-3xl bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-bold text-navy">Analytics</h1>
        <p className="mt-2 text-sm text-slate-600">View platform performance metrics and analytics.</p>
      </div>
    </DashboardShell>
  );
}

export default AdminAnalyticsPage;
